import { gsap, ScrollToPlugin } from "../global/gsap";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

// Set the options for loading the API.
setOptions({ key: "AIzaSyBP-Tpwni48KEKTGF3YaiWCjOupLT6vSf8" });

const initLondonMap = async (londonMapEl) => {
    const markerStorage = {
        industry: [],
        cultural: []
    };

    const filterMarkers = (targetType) => {
        Object.keys(markerStorage).forEach((category) => {
            markerStorage[category].forEach((marker) => {
                if (targetType === 'all' || category === targetType) {
                    marker.map = map;
                } else {
                    marker.map = null;
                }
            });
        });
    };

    const { Map } = await importLibrary("maps");
    const { AdvancedMarkerElement } = await importLibrary("marker");

    const mapEl = londonMapEl.querySelector('.js-map');
    const overlay = londonMapEl.querySelector('.js-overlay');
    const toggleBtns = londonMapEl.querySelectorAll('.js-map-btn');
    const expandBtn = londonMapEl.querySelector('.js-expand-btn');

    let isExpanded = false;

    const mapArgs = {
        zoom: 13,
        center: {
            lat: 51.516239,
            lng: -0.1213924
        },
        mapId: "cc814f174db119222c676c73",
        disableDefaultUI: true,
        gestureHandling: "greedy",
        backgroundColor: "#1F1414"
    };

    const map = new Map(mapEl, mapArgs);

    mapMarkersData.forEach((data) => {
        const markerContainer = document.createElement('div');
        markerContainer.className = `london-map__marker type-${data.type}`;

        const pinBg = document.createElement('img');
        pinBg.src = `${themeData.svgPath}marker-bg.svg`;
        pinBg.className = 'london-map__marker-bg';
        markerContainer.appendChild(pinBg);

        if (data.logo && data.logo.url) {
            const logoImg = document.createElement('img');
            logoImg.src = data.logo.url;
            logoImg.className = 'london-map__marker-logo';
            markerContainer.appendChild(logoImg);
        }

        const marker = new AdvancedMarkerElement({
            map,
            position: {
                lat: parseFloat(data.location.lat),
                lng: parseFloat(data.location.lng)
            },
            title: data.title,
            content: markerContainer
        });
        markerStorage[data.type].push(marker);
    });

    toggleBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => { 
            e.preventDefault();

            toggleBtns.forEach((item) => item.classList.remove('is-active'));
            btn.classList.add('is-active');

            const selectedType = btn.dataset.type;
            filterMarkers(selectedType);
        });
    });

    filterMarkers(toggleBtns[0].dataset.type);

    // LFS Marker
    const staticLocation = { lat: 51.516232, lng: -0.1239121 };
    const staticContainer = document.createElement('div');
    staticContainer.className = 'london-map__lfs-marker';

    const staticPin = document.createElement('img');
    staticPin.src = `${themeData.svgPath}lfs-marker.svg`;
    staticPin.className = 'london-map__marker-bg';
    staticContainer.appendChild(staticPin);

    const lfsMarker = new AdvancedMarkerElement({
        map,
        position: staticLocation,
        content: staticContainer,
        title: "LFS",
        zIndex: 999
    });

    // overlay.addEventListener('click', (e) => { 
    //     e.preventDefault();
    //     overlay.style.display = "none";
    // });

    expandBtn.addEventListener('click', (e) => {
        e.preventDefault();
        isExpanded = !isExpanded;

        if (isExpanded) {
            londonMapEl.classList.add('is-expanded');
            overlay.style.display = "none";

            gsap.to(londonMapEl, {
                height: "100vh"
            });

            gsap.to(window, {
                scrollTo: {
                    y: londonMapEl,
                    autoKill: false
                }
            });
        } else {
            londonMapEl.classList.remove('is-expanded');
            overlay.style.display = "block";

            gsap.to(londonMapEl, {
                height: "70vh"
            });
        }
    });

    return map;
};

export { initLondonMap as default };
